import avatar3 from "@assets/avatars/avatar-5.svg";
import jinx from "@assets/jinx.svg";
import AvatarWithText from "@core-components/avatar-text/AvatarWithText";
import SSBackgroundImage from "@core-components/backgroundImage/BackgroundImage";
import SSBgImageHeadline from "@core-components/backgroundImage/components/BgImageHeadline";
import ButtonVariants from "@core-components/button/ButtonVariants";
import Emoji from "@core-components/emoji/Emoji";
import SSHeadline from "@core-components/title/SSHeadline";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Image, SimpleGrid, Stack, Text } from "@mantine/core";

const ErrorPage = () => {
  const { t } = useAppTranslation("pages.error");

  return (
    <div>
      <SSBackgroundImage>
        <SSBgImageHeadline
          subTitle={<AvatarWithText avatar={avatar3} text={[t("text")]} />}
        >
          <SSWhiteText>{t("title")}</SSWhiteText>
          <br />
          <SSLoLGradientText>{t("subtitle")}</SSLoLGradientText>
        </SSBgImageHeadline>
      </SSBackgroundImage>

      <div className="flex flex-row justify-center">
        <SimpleGrid
          className="px-2 xs:px-5 py-16 sm:px-10"
          cols={{ base: 1, md: 2 }}
          maw={1300}
        >
          <Stack align="center" justify="center">
            <SSHeadline props={{ title: { fz: 35 } }}>
              <Emoji.Hand />
              <SSWhiteText> {t("panic")}</SSWhiteText>
            </SSHeadline>
            <Text
              className="max-w-[500px] text-center font-inter font-normal text-primary-light-text"
              size="lg"
            >
              {t("description")}
            </Text>
            <ButtonVariants.JoinDiscord className="rounded-full px-10" />
          </Stack>
          <Image
            className="hidden md:block"
            fit="contain"
            loading="lazy"
            src={jinx}
          />
        </SimpleGrid>
      </div>
    </div>
  );
};

export default ErrorPage;
